// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdministrativeAreasController from "./administrative_areas_controller.js"
application.register("administrative-areas", AdministrativeAreasController)

import AjaxSubmitterController from "./ajax_submitter_controller.js"
application.register("ajax-submitter", AjaxSubmitterController)

import CharacterCounterController from "./character_counter_controller.js"
application.register("character-counter", CharacterCounterController)

import CheckboxLimitController from "./checkbox_limit_controller.js"
application.register("checkbox-limit", CheckboxLimitController)

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import DependentSelectController from "./dependent_select_controller.js"
application.register("dependent-select", DependentSelectController)

import DropdownController from "./dropdown_controller.js"
application.register("dropdown", DropdownController)

import FieldToggleController from "./field_toggle_controller.js"
application.register("field-toggle", FieldToggleController)

import InfiniteScrollController from "./infinite_scroll_controller.js"
application.register("infinite-scroll", InfiniteScrollController)

import ListboxController from "./listbox_controller.js"
application.register("listbox", ListboxController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import PopupWindowController from "./popup_window_controller.js"
application.register("popup-window", PopupWindowController)

import PushStateController from "./push_state_controller.js"
application.register("push-state", PushStateController)

import TextCounterController from "./text_counter_controller.js"
application.register("text-counter", TextCounterController)

import ToggleActiveController from "./toggle_active_controller.js"
application.register("toggle-active", ToggleActiveController)

import ToggleVisibilityController from "./toggle_visibility_controller.js"
application.register("toggle-visibility", ToggleVisibilityController)

import VideoLoadController from "./video_load_controller.js"
application.register("video-load", VideoLoadController)

import VideoSearchController from "./video_search_controller.js"
application.register("video-search", VideoSearchController)
